import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PopupType } from '../../types/popup/popup-type';

@Component({
  selector: 'tcat-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit {

  popupTypes = PopupType;

  @Input()
  popupType = PopupType.LARGE;

  @Input()
  zIndex = 2000;

  isShowing = false;

  @Input()
  title: string = '';

  @Output()
  close = new EventEmitter<string>();



  constructor() { }

  ngOnInit(): void {
  }


  show() {
    this.isShowing = true;
  }

  hide() {
    this.isShowing = false;
  }

  cancel() {
    this.close.emit('cancel');
  }

  suppress(event: any) {
    event.stopPropagation();
  }

}
